import { useState, useEffect } from "react";

import QuizServices from "../../../services/QuizServices";
import SchoolHeader from "../header";
import SchoolSidebar from "../sidebar";
import TeacherServices from "../../../services/TeacherServices";
import { Link } from "react-router-dom";
import { addYears, format } from "date-fns";

const SchoolDashboard = () => {
  // const [isClassAdded, setIsClassAdded] = useState([false]);

  // const toggleClass = (index) => {
  //   const updatedClasses = [...isClassAdded];
  //   updatedClasses[index] = !updatedClasses[index];
  //   setIsClassAdded(updatedClasses);
  // };
  const [Teachernumber, setTeachernumber] = useState(0);
  const [Quizcompleted, setIsQuizcompleted] = useState(false);

  const [courseVidoes, setCourseVideos] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);

  const userobj = JSON.parse(localStorage.getItem("user"));
  const userid = userobj._id;
  const createdAt = new Date(userobj.createdAt);
  const formattedDate = format(createdAt, "MM/dd/yyyy");
  const nextYear = addYears(createdAt, 1);
  const formattedExpirationDate = format(nextYear, "MM/dd/yyy");
  const fetchdashboard =
    (async () => {
      try {
        const response = await TeacherServices.getdashboardTeachers();

        if (response) {
          console.log(response);
        } // Ensure this is an array
      } catch (error) {
        console.error("Error fetching Teachers:", error);
      }
    },
    [Teachernumber]);
  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await TeacherServices.getdashboardTeachers();
        if (response) {
          console.log(response);
          setTeachernumber(response.total_teachers);
          if (response.quizResults) {
            setIsQuizcompleted(true);
          }
        }
      } catch (error) {
        console.error("Error fetching Teachers:", error);
      }
    };

    fetchDashboard();
  }, [Teachernumber]); // Dependency array should be here
  console.log("userobj", userobj);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await TeacherServices.getVideosWithQuiz(userobj._id);
        if (response && response.videos) {
          setCourseVideos(response.videos);
        }
      } catch (error) {}
    };

    const fetchTeacherData = async () => {
      try {
        const data = await QuizServices.getProcess(userobj._id, 1);
        setCurrentVideoIndex(data.currentVideoIndex);
        setCurrentGroupIndex(data.currentGroupIndex);
      } catch (error) {}
    };

    fetchVideos();
    fetchTeacherData();
  }, []);

  const completedBefore = courseVidoes
    .filter((_, index) => index < currentVideoIndex)
    .flatMap((group) =>
      group.quizzes.map((quiz) => ({
        ...quiz,
        status: "Completed",
      }))
    );

  const completedCurrent = courseVidoes.flatMap((group, groupIndex) =>
    groupIndex === currentVideoIndex
      ? group.quizzes
          .filter((_, quizIndex) => quizIndex < currentGroupIndex)
          .map((quiz) => ({
            ...quiz,
            status: "Completed",
          }))
      : []
  );

  const notCompleted = courseVidoes.flatMap((group, groupIndex) =>
    groupIndex === currentVideoIndex
      ? group.quizzes
          .filter((_, quizIndex) => quizIndex >= currentGroupIndex)
          .map((quiz) => ({
            ...quiz,
            status: "Not Completed",
          }))
      : []
  );

  const notCompletedAfter = courseVidoes
    .filter((_, index) => index > currentVideoIndex)
    .flatMap((group) =>
      group.quizzes.map((quiz) => ({
        ...quiz,
        status: "Not Completed",
      }))
    );

  const allRows = [
    ...completedBefore,
    ...completedCurrent,
    ...notCompleted,
    ...notCompletedAfter,
  ];


  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <SchoolHeader activeMenu={"Dashboard"} />
        {/* /Header */}
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">
                    {" "}
                    {userobj.type === "Individual"
                      ? "Individual Teacher"
                      : "Director/Owner Dashboard"}{" "}
                  </h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/school-dashboard">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Dashboard
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* sidebar */}
              <SchoolSidebar />
              {/* /Sidebar */}
              {/* School Dashboard */}
              <div className="col-xl-9 col-lg-9">
                {/* Dashboard Grid */}
                <div className="row justify-content-center">
                  {userobj.type !== "Individual" ? (
                    <div className="col-lg-3 col-md-6 d-flex">
                      <div className="card dash-info flex-fill">
                        <div className="card-body">
                          <h5>Teachers</h5>
                          <h2>{Teachernumber}</h2>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-3 col-md-6 d-flex">
                      <div className="card dash-info flex-fill">
                        <div className="card-body d-flex flex-column justify-content-between">
                          <h5>Sign Up Date</h5>
                          <h3>{formattedDate}</h3>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-3 col-md-6 d-flex">
                    <div className="card dash-info flex-fill">
                      <div className="card-body">
                        <h5>Course</h5>
                        <h3>
                          {Quizcompleted ? (
                            <Link
                              to="/certificates"
                              className="list-view active"
                            >
                              View Certificates
                            </Link>
                          ) : (
                            <Link
                              to="/test/mcq-test"
                              className="list-view active"
                            >
                              Take Course
                            </Link>
                          )}
                        </h3>
                      </div>
                    </div>
                  </div>

                  {Quizcompleted && (
                    <div className="col-lg-3 col-md-6 d-flex">
                      <div className="card dash-info flex-fill">
                        <div className="card-body">
                          <h5>Retake</h5>
                          <h3>
                            <Link
                              to="/test/mcq-test"
                              className="list-view active"
                            >
                              Retake Course
                            </Link>
                          </h3>
                        </div>
                      </div>
                    </div>
                  )}
                  {userobj.type !== "Individual" ? (
                    <div className="col-lg-3 col-md-6 d-flex">
                      <div className="card dash-info flex-fill">
                        <div className="card-body">
                          <h5> </h5>
                          <h3>
                            {" "}
                            <Link
                              to={`/emergencycertificate/${userid}`}
                              className="list-view active"
                            >
                              Emergency Protocols
                            </Link>
                          </h3>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-3 col-md-6 d-flex">
                      <div className="card dash-info flex-fill">
                        <div className="card-body d-flex flex-column justify-content-center">
                          <h5>Expiration Date </h5>
                          <h3>{formattedExpirationDate}</h3>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className="table-responsive custom-table">
                    <table
                      id="orderHistoryTable"
                      className="table table-nowrap mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Video Order</th>
                          <th>Video Course Name</th>
                          <th>Status</th>
                          <th>Take Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allRows.map((quiz, index) => (
                          <tr key={quiz._id}>
                            <td>{index + 1}</td>
                            <td>{quiz.videoName}</td>
                            <td
                              style={{
                                color:
                                  quiz.status === "Completed" ? "green" : "red",
                              }}
                            >
                              {quiz.status}
                            </td>
                            <td>
                              {quiz.status === "Completed" ? (
                                <Link
                                  to={`/test/mcq-test?teacher_id=${userobj._id}&video_id=${index}`}
                                >
                                  Retake Action
                                </Link>
                              ) : (
                                <Link
                                  to={`/test/mcq-test?teacher_id=${userobj._id}`}
                                >
                                  Take Action
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* /Dashboard Grid */}
              </div>

              {/* School Dashboard */}
            </div>
          </div>
        </div>
        {/* /Page Content */}
        {/* Footer */}

        {/* /Footer */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default SchoolDashboard;
